import { openBlock as o, createElementBlock as t, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M10.575 5.895c1.301.547 2.366.262 3.675-.15 1.942-.502 3.407-.342 5.172.628.613.427.94.853 1.218 1.547l-.54.375c-1 .887-1.526 1.633-1.721 2.947-.067 1.46.069 2.532.938 3.728.546.586 1.105.96 1.803 1.35-.292 2.336-1.88 4.367-3.57 5.91-1.266.557-2.383.27-3.66-.165-1.196-.39-2.158-.344-3.3.15-1.064.434-2.054.465-3.15.105-1.017-.675-1.654-1.515-2.295-2.535l-.284-.448C3.092 16.467 2.44 13.28 2.982 9.93c.454-1.6 1.415-2.877 2.812-3.782 1.6-.797 3.123-.951 4.781-.252"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M16.56.24c-.057 1.785-.449 2.993-1.68 4.32-.967.702-1.906 1.112-3.12.96.057-1.785.449-2.994 1.68-4.32.967-.702 1.906-1.112 3.12-.96"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
